import api from './api';
import { PAYMENT_API } from '../utils/constants';

/**
 * ⚠️ SAARA PAISA PAISE MEIN AATA HAI aur PAISE MEIN JAATA HAI.
 *    50000 = ₹500
 *
 * Dikhane ke liye utils/money.js ka formatPaise() use karo.
 */

// ============================================================
// RAZORPAY
// ============================================================

/**
 * Razorpay order banao.
 *
 * ⚠️ AMOUNT YAHAN NAHI BHEJTE - jaan-boojh ke.
 * Backend booking se amount nikalta hai. Agar frontend amount
 * bhejta to koi bhi console se ₹1 bhej ke ₹5000 ki pooja book
 * kar leta.
 *
 * @param bookingId   kaunsi booking
 * @param paymentType 'ADVANCE' | 'BALANCE' | 'FULL'
 * @returns { paymentId, razorpayOrderId, razorpayKeyId,
 *            amountInPaise, currency, bookingId, poojaType,
 *            userName, userEmail, userPhone }
 */
export const createRazorpayOrder = async (bookingId, paymentType) => {
    const response = await api.post(`${PAYMENT_API}/create-order`, {
        bookingId,
        paymentType,
    });
    return response.data;
};

/**
 * Payment verify karo - Razorpay Checkout ke handler se.
 *
 * ⚠️ Ye call ZAROORI hai. Checkout ka handler chalne ka matlab
 * payment confirm hona NAHI hai - backend signature verify karega
 * tabhi paisa maana jayega.
 *
 * @param razorpayResponse Checkout ke handler se jo object aata hai
 */
export const verifyRazorpayPayment = async (razorpayResponse) => {
    const response = await api.post(`${PAYMENT_API}/verify`, {
        razorpayOrderId: razorpayResponse.razorpay_order_id,
        razorpayPaymentId: razorpayResponse.razorpay_payment_id,
        razorpaySignature: razorpayResponse.razorpay_signature,
    });
    return response.data;
};

// ============================================================
// QUERIES
// ============================================================

// Get all payments for a booking
export const getPaymentsByBooking = async (bookingId) => {
    const response = await api.get(
        `${PAYMENT_API}/booking/${bookingId}`);
    return response.data;
};

// Get payments by user
export const getPaymentsByUser = async (userId) => {
    const response = await api.get(
        `${PAYMENT_API}/user/${userId}`);
    return response.data;
};

// Get payments by poojari
export const getPaymentsByPoojari = async (poojariId) => {
    const response = await api.get(
        `${PAYMENT_API}/poojari/${poojariId}`);
    return response.data;
};

// Get total paid for a booking - PAISE mein
export const getTotalPaidByBooking = async (bookingId) => {
    const response = await api.get(
        `${PAYMENT_API}/total/booking/${bookingId}`);
    return response.data;
};

// Get payment summary by user - amounts PAISE mein
export const getPaymentSummaryByUser = async (userId) => {
    const response = await api.get(
        `${PAYMENT_API}/summary/user/${userId}`);
    return response.data;
};

// Get payment summary by poojari - amounts PAISE mein
export const getPaymentSummaryByPoojari = async (
        poojariId) => {
    const response = await api.get(
        `${PAYMENT_API}/summary/poojari/${poojariId}`);
    return response.data;
};

// Total earnings by poojari - PAISE mein
// ⚠️ Ye GROSS hai - commission kata hua nahi
export const getTotalEarningsByPoojari = async (
        poojariId) => {
    const response = await api.get(
        `${PAYMENT_API}/earnings/poojari/${poojariId}`);
    return response.data;
};

/**
 * Process refund.
 *
 * ⚠️ refundData mein field ka naam ab "refundAmountInPaise" hai,
 * "refundAmount" nahi. Backend ne naam badla hai taaki purana
 * caller chupchaap 100 guna kam refund na kar de.
 *
 * @param refundData { refundAmountInPaise, refundReason }
 */
export const processRefund = async (id, refundData) => {
    const response = await api.put(
        `${PAYMENT_API}/refund/${id}`, refundData);
    return response.data;
};

// ============================================================
// ⚠️ HATAYE GAYE FUNCTIONS
//
// createPayment()    - purana simulation wala rasta
// completePayment()  - "payment ho gaya" bina kisi payment ke
// failPayment()
// makePayment()      - createPayment + completePayment ek saath
//
// makePayment() SABSE KHATARNAK tha: koi bhi user browser console
// se ye call karke apni booking "paid" mark karwa sakta tha, bina
// ek rupaya diye. Wo gateway aane tak ka jugaad tha.
//
// Ab asli rasta: createRazorpayOrder() -> Checkout -> verify()
// Backend signature verify karta hai, isliye jhooth nahi chalega.
//
// Cash payments ab booking-service se handle hote hain
// (poojariMarkComplete), payment-service se nahi.
// ============================================================